import React from "react"
import { Badge } from "../../../components/ui/badge"

const ProgramCoursesTab = ({ courses, selectedCourseIds, onChange }) => {
  const toggleCourse = (courseId) => {
    onChange(selectedCourseIds?.includes(courseId) ? selectedCourseIds?.filter((id) => id !== courseId) : [...selectedCourseIds, courseId])
  }

  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <h3 className="text-sm font-semibold text-foreground uppercase tracking-wide mb-1">Courses in this Program</h3>
      <p className="text-sm text-muted-foreground mb-4">{selectedCourseIds?.length || 0} selected</p>

      {courses?.length === 0 ? (
        <p className="text-sm text-muted-foreground border border-dashed border-border rounded-md p-4">
          No courses exist yet — create one first, then come back to bundle it in.
        </p>
      ) : (
        <div className="border border-border rounded-md divide-y divide-border">
          {courses?.map((course) => (
            <label key={course?.courseId} className="flex items-center gap-2 px-3 py-2.5 text-sm cursor-pointer hover:bg-muted/50 transition-colors">
              <input
                type="checkbox"
                checked={selectedCourseIds?.includes(course?.courseId)}
                onChange={() => toggleCourse(course?.courseId)}
                className="rounded border-border"
              />
              <span className="flex-1 text-foreground truncate">{course?.title}</span>
              <Badge variant={course?.status === "published" ? "success" : "warning"} className="shrink-0">
                {course?.status === "published" ? "Published" : "Draft"}
              </Badge>
            </label>
          ))}
        </div>
      )}
    </div>
  )
}

export default ProgramCoursesTab